import React, {Component} from 'react';

import ImageWrapper from './ImageWrapper.js';
import yogaGirls from 'img/yoga-girls.jpg';
import jordanCox from 'img/jordan-cox.jpg';
import diverseOffice from 'img/diverse-office.jpg';
import happyLady from 'img/happy-lady.jpg';
import runningLady from 'img/running-lady.jpg';
import saladMan from 'img/salad-man.jpg';

const images = [
    {src:yogaGirls,
     backgroundPosition:'50% 50%', 
     backgroundSize:'cover',
    },
    {src:jordanCox,
     backgroundPosition:'50% 50%', 
     backgroundSize:'cover',
    },
    {src:happyLady,
     backgroundPosition:'60% 50%', 
     backgroundSize:'cover',
    },
    {src:runningLady,
     backgroundPosition:'50% 50%', 
     backgroundSize:'cover',
    },
    {src:saladMan,
     backgroundPosition:'50% 50%', 
     backgroundSize:'cover',
    },
    {src:diverseOffice,
     backgroundPosition:'15% 50%', 
     backgroundSize:'cover',
    }
];
const imageChangePeriodMS = 5000;

class ImageWrapperContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {imageOffset:0}
        this.tick = this.tick.bind(this);
    }

    tick() {
        this.setState(prevState => ({imageOffset: prevState.imageOffset+1}));
    }

    componentWillMount() {
        this.timerId = setInterval(this.tick, imageChangePeriodMS)
    }

    componentWillUnmount() {
        clearInterval(this.timerId);
    }

    render() {
        var offset = this.state.imageOffset%images.length;
        return <ImageWrapper {...this.props} 
                             {...this.state}
                             images={images}
                             offset={offset}/>;
    }
}

export default ImageWrapperContainer;



// WEBPACK FOOTER //
// ./src/modules/authentication/ImageWrapperContainer.js